const items = { drawer: true, isLoading: false };
const initialState = items;

export const theme = {
    namespaced: true,
    state: initialState,
    actions: {
        updateDrawer({ commit }) {
            commit('updateDrawer');
        },
        updateIsLoading({ commit }, updateVal) {
            commit('updateLodingState', updateVal);
        }
    },
    mutations: {
        updateDrawer(state) {
            state.drawer = state.drawer === true ? false : true;
        },
        updateLodingState(state, updateVal) {

            state.isLoading = updateVal;
        },

    }
};